import { mapActions, mapGetters, mapMutations } from 'vuex';
import { disableBodyScroll } from 'body-scroll-lock';
import { trapFocus } from 'utils/general';
import select from 'dom-select';

export default {
  props: {
    handle: String,
    title: String,
    type: {
      type: String,
      default: 'box',
    },
    contentType: String,
    extraClasses: {
      type: String,
      default: '',
    },
    backButtonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalElement: null,
      isMounted: false,
    };
  },
  mounted() {
    this.bodyElement = document.body;
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  updated() {
    const element = this.$el;
    if (element.classList.contains('active')) {
      const closeButton = element.querySelector('.modal__close')
      closeButton.focus();
    }
    if (!this.isActive) {
      this.resetWrapperHeight();
      return;
    }

    this.$nextTick(() => {
      disableBodyScroll(this.$refs.container);
      // Phone bottom bar height overflow fix (Android and Ios)
      this.setWrapperHeight();
    });

    console.log('modal opened')
    const focusableSelectors = [
      'a[href]',
      'area[href]',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'button:not([disabled])',
      'iframe',
      'object',
      'embed',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable]'
    ];

    const focusableElements = Array.from(this.$el.querySelectorAll(focusableSelectors.join(','))).filter(element => element.offsetParent !== null);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    firstFocusableElement.focus();

    this.$el.addEventListener('keydown', function(e) {
      if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    });
  },
  computed: {
    ...mapGetters('global', ['currentModal']),
    isActive() {
      return this.isMounted && this.currentModal === this.handle;
    },
    modalContentClasses() {
      let classList = ['modal__inner'];
      if (this.contentType) {
        classList = classList.concat(this.contentType.split(' '));
      }
      return classList;
    },
    modalClasses() {
      if (this.$scopedSlots.footer) {
        return 'modal__with-footer';
      }
      return ' ';
    },
    transition() {
      if (this.type === 'slideout') {
        return 'slide-left';
      }

      return 'slide-fade';
    },
    isSlideout() {
      return this.type === 'slideout';
    },
  },
  methods: {
    ...mapActions('global', ['setForm', 'openModal', 'closeModal']),
    ...mapActions('quickView', ['setGWPModal']),
    ...mapMutations('global', ['setOnlyOneProductGWP']),
    toggleBackgroundLock() {
      if (!this.isActive) return;

      if (this.currentModal === 'gwp') {
        const scrollEl = select('.js-modal-overflow-el', this.$el);
        if (scrollEl) {
          disableBodyScroll(scrollEl);
        }
      } else {
        disableBodyScroll(this.$refs.container);
      }
      this.$el.parentElement.setAttribute('aria-hidden', 'false');
    },
    closeCurrentModal() {
      this.closeModal();
      this.setGWPModal(false);
      this.setOnlyOneProductGWP(false);
      this.$el.parentElement.setAttribute('aria-hidden', 'true');

      const videoThumbnail = document.querySelector('.product-gallery__thumbs__item.active')
      if (videoThumbnail) {
        videoThumbnail.focus();
      }
    },
    resetWrapperHeight() {
      if (this.$refs.wrapper) {
        this.$refs.wrapper.removeAttribute('style');
      }
    },
    setWrapperHeight() {
      if ((this.$refs.wrapper || {}).offsetHeight > window.innerHeight) {
        this.$refs.wrapper.style.height = `${window.innerHeight}px`;
      }
    },
  },
  watch: {
    currentModal() {
      this.$nextTick(() => {
        this.toggleBackgroundLock();
      });
    },
  },
  template: '#modal-template',
};
